/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminClientListCompletedOnboardingStepsInner
 */
export interface AdminClientListCompletedOnboardingStepsInner {
    /**
     * 
     * @type {string}
     * @memberof AdminClientListCompletedOnboardingStepsInner
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminClientListCompletedOnboardingStepsInner
     */
    internalIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof AdminClientListCompletedOnboardingStepsInner
     */
    readableName: string;
    /**
     * 
     * @type {number}
     * @memberof AdminClientListCompletedOnboardingStepsInner
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof AdminClientListCompletedOnboardingStepsInner
     */
    information?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminClientListCompletedOnboardingStepsInner
     */
    stepCompleted?: boolean;
}

/**
 * Check if a given object implements the AdminClientListCompletedOnboardingStepsInner interface.
 */
export function instanceOfAdminClientListCompletedOnboardingStepsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;

    return isInstance;
}

export function AdminClientListCompletedOnboardingStepsInnerFromJSON(json: any): AdminClientListCompletedOnboardingStepsInner {
    return AdminClientListCompletedOnboardingStepsInnerFromJSONTyped(json, false);
}

export function AdminClientListCompletedOnboardingStepsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminClientListCompletedOnboardingStepsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'internalIdentifier': json['internal_identifier'],
        'readableName': json['readable_name'],
        'order': json['order'],
        'information': !exists(json, 'information') ? undefined : json['information'],
        'stepCompleted': !exists(json, 'step_completed') ? undefined : json['step_completed'],
    };
}

export function AdminClientListCompletedOnboardingStepsInnerToJSON(value?: AdminClientListCompletedOnboardingStepsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'internal_identifier': value.internalIdentifier,
        'readable_name': value.readableName,
        'order': value.order,
        'information': value.information,
        'step_completed': value.stepCompleted,
    };
}

